import { createSelector } from "reselect";

export const SecuritySelector = state => state.security;
export const UserSelector = state => state.security.user;

export const isSignedInSelector = createSelector(
  SecuritySelector,
  security => security.signedIn === true
);
